import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../store/redux/hooks'
import { PageIndex, setPageIndex, setPageName } from '../../store/redux/reducers/pageNameSlice'
import { StyledPageContent } from '../../styles/PageStyles'
import { Grid, Box } from '@mui/material'
import MasonryTileCalendar from './MasonryTileCalendar'
import { monthPickerActions } from '../../store/redux/reducers/monthPickerSlice'
import { pageHeaderActions } from '../../store/redux/reducers/pageHeaderSlice'
import dayjs from 'dayjs'
import UpcomingVacationsTable from '../../components/Table/UpcomingVacationsTable/UpcomingVacationsTable'

const LeaderView = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setPageName(t('page.name.leaderView')))
    dispatch(setPageIndex(PageIndex.LEADER_VIEW))
    dispatch(pageHeaderActions.setInitialState())
    dispatch(monthPickerActions.setDate(dayjs().toString()))
  }, [dispatch, t])

  const [isCalendarWeekly, setIsCalendarWeekly] = useState<boolean>(true)

  return (
    <StyledPageContent sx={{ paddingRight: 0, paddingBottom: 3 }}>
      <Grid
        container
        columns={{ xs: 4, sm: 4, md: 4, lg: 8 }}
        spacing={3}
        sx={{ maxHeight: { md: 'none', lg: 1800 }, paddingBottom: 3 }}
      >
        <Grid item xs={8} sx={{ width: '100%' }}>
          <MasonryTileCalendar isWeeklyRange={isCalendarWeekly} setIsWeeklyRange={setIsCalendarWeekly} />
        </Grid>
      </Grid>
      <Box mt={3} mb={6}>
        <Grid container justifyContent="flex-start" pb={3}>
          <Grid item xs={12} lg={8}>
            <UpcomingVacationsTable />
          </Grid>
        </Grid>
      </Box>
    </StyledPageContent>
  )
}

export default LeaderView
